import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import io from 'socket.io-client'
import { iff, discard } from 'feathers-hooks-common'
import feathersVuex from 'feathers-vuex'
//import { apiClient } from '@/api'

const botApiUrl = localStorage.getItem('botApiUrl') || 'http://localhost:3060'

console.log(`Using Bot API URL: ${botApiUrl || process.env.VUE_APP_API_URL}`)

const botSocket = io(botApiUrl || process.env.VUE_APP_API_URL, { transports: ['websocket'], upgrade: false })

const apiErrorHandler = async context => {
  const { service, error } = context;
  console.log('Bot error: ', error, context.hook && context.hook.path)

  if (error && error.code === 401) {
    console.log('Bot emit session expired...')
    //apiClient.emit("authentication", { event: "session-expired" });
  } else if (error && error.code === 403) {
    service.FeathersVuexModel.store.commit('app/appMessage', {
      text: `${error.message} (${error.hook.path}.${error.hook.method})`,
      color: 'error',
      timeout: 5000
    })
  } else if (error.name === 'Timeout' && service.FeathersVuexModel && service.FeathersVuexModel.store) {
    const selectedBot = service.FeathersVuexModel.store.getters['app/selectedBot']
    let message = selectedBot && selectedBot.active ? 'Your bot is currently applying changes...' : 'Your bot is currently inactive and offline...'

    service.FeathersVuexModel.store.commit('app/appMessage', {
      text: message,
      timeout: 5000
    })
  }
  return context;
};

const botClient = feathers()
  .configure(socketio(botSocket, {
    timeout: 15000
  }))
  .configure(auth({ storage: window.localStorage }))
  .hooks({
    before: {
      all: [
        iff(
          context => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp')
        )
      ]
    },
    error: {
      all: [apiErrorHandler]
    }
  })

// Setting up feathers-vuex
const { makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex } = feathersVuex(
  botClient,
  {
    serverAlias: 'bot', // optional for working with multiple APIs (this is the default value)
    idField: 'id', // Must match the id field in your database table/collection
    whitelist: ['$regex', '$options', '$ilike'],
    paramsForServer: ['$eager', '$joinRelation', '$modify', 'api_key'],
  }
)


export { botClient, makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex }